import { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import { apiGet, apiPost } from '../api';
import { IOrderHistory, ILogisticServiceHistory } from '../../types/suscription/history.types';
import { IOrderHistoryWithShipmentsResponse, IOrderStatusLogLastUpdate } from '../../types/order-status-log.types';
import { IInspectionReportUrlResponse } from 'types/tool-inspection-information.types';

const { REACT_APP_SUBSCRIPTION } = process.env;

/**
 * Obtiene el historial de la orden (con usuario responsable por cambio)
 * y el historial de estados de cada envío.
 */
export const getOrderHistoryWithShipments = async (orderId: number): Promise<IOrderHistoryWithShipmentsResponse> => {
  return apiGet<AxiosRequestConfig, IOrderHistoryWithShipmentsResponse>(
    `${REACT_APP_SUBSCRIPTION}/order-status-log/history/${orderId}/with-shipments`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Obtiene la última actualización de estado de la orden (order-status-log) para el bloque "Última actualización".
 */
export const getOrderStatusLogLastUpdate = async (orderId: number): Promise<IOrderStatusLogLastUpdate | null> => {
  return apiGet<AxiosRequestConfig, IOrderStatusLogLastUpdate | null>(
    `${REACT_APP_SUBSCRIPTION}/order-status-log/last-update/${orderId}`
  )
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getOrderHistory = async (orderId: number): Promise<IOrderHistory[]> => {
  return apiGet<AxiosRequestConfig, IOrderHistory[]>(`${REACT_APP_SUBSCRIPTION}/order-history/${orderId}`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

export const getLogisticServiceHistory = async (serviceId: number): Promise<ILogisticServiceHistory[]> => {
  return apiGet<AxiosRequestConfig, ILogisticServiceHistory[]>(`${REACT_APP_SUBSCRIPTION}/service-history/${serviceId}`)
    .then(resp => Promise.resolve(resp))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Solicita la URL del reporte DSN (PDF) para un producto del servicio logístico.
 * @param logisticServiceProductId - ID del producto dentro del servicio logístico
 */
export const postGenerateDsnReportByLogisticServiceProduct = async (logisticServiceProductId: number) => {
  return apiPost<AxiosRequestConfig, undefined, AxiosResponse<IInspectionReportUrlResponse>>(
    `${REACT_APP_SUBSCRIPTION}/tool-inspection-information/generate-report/by-logistic-service-product/${logisticServiceProductId}`,
    undefined
  )
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => Promise.reject(error));
};

/**
 * Solicita la URL del reporte DSN (PDF) por ID de inspección.
 * @param toolInspectionId - ID de la inspección asociada al evento
 */
export const postGenerateDsnReportByToolInspectionId = async (toolInspectionId: number) => {
  return apiPost<AxiosRequestConfig, undefined, AxiosResponse<IInspectionReportUrlResponse>>(
    `${REACT_APP_SUBSCRIPTION}/tool-inspection-information/generate-report/by-tool-inspection/${toolInspectionId}`,
    undefined
  )
    .then(response => Promise.resolve(response.data))
    .catch((error: AxiosError) => Promise.reject(error));
};
